import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Button } from 'components/misc'
import styles from './person-role.styl'
import { ROLES } from 'constants/enums'
import { Link } from 'react-router-dom'
import config from 'config'

export default class PersonRole extends Component {
  static propTypes = {
    id: PropTypes.number,
    contactId: PropTypes.number,
    key: PropTypes.number,
    roleCount: PropTypes.number,
    role: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    isOwnContact: PropTypes.bool,
    deletePersonRole: PropTypes.func.isRequired,
  }

  getRoleName(role, contactId) {
    const roleNameSpan = <span className={styles.type}>{get(role, 'organizationContactRoleType.translationText')}</span>

    if (get(role, 'organizationContactRoleType.value') === ROLES.LEADER.role) {
      return <Link to={`${config.publicPath}/leaders/${contactId}/detail`}>{roleNameSpan}</Link>
    }
    return roleNameSpan
  }

  render() {
    const {
      role,
      isLoading,
      isOwnContact,
      contactId,
      roleCount,
      deletePersonRole
    } = this.props

    return (
      <div className={styles.role}>
        <div className="row">
          <div className="col-xs-9">
            {this.getRoleName(role, contactId)}
            <span className={styles.name}>{get(role, 'organizationName')}</span>
          </div>
          <div className="col-xs-3 text--right">
            {!isOwnContact && (
              <Button
                type="button"
                tiny
                secondary
                isLoading={isLoading}
                intlKey="button.role_delete"
                disabled={!role.isEditable}
                onClick={() => deletePersonRole(role, roleCount)}
                className={styles.btn}
              >
                Delete
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }
}
